import { datadogLogs } from '@datadog/browser-logs';
import { CONFIG } from '@frameio/config';
import { isServer } from '@frameio/utils/config';
import { log } from '@frameio/utils/log';

function initDatadogLogger() {
  const { datadogRum: datadogConfig } = CONFIG.thirdParty;
  if (!datadogConfig) return;

  try {
    datadogLogs.init({
      clientToken: datadogConfig.clientToken,
      service: datadogConfig.service,
      env: datadogConfig.env,
      forwardErrorsToLogs: false,
      sessionSampleRate: 100,
      version: CONFIG.releaseVersion,
    });
  } catch (e) {
    log.error(e);
  }
}

function withEnsureInit<T extends (...args: any[]) => any>(fn: T): T {
  return ((...args: Parameters<T>): void => {
    if (!datadogLogs.getInitConfiguration()) {
      initDatadogLogger();
    }
    try {
      fn.bind(datadogLogs.logger)(...args);
    } catch (e) {
      // Browser-logs assumes you are client side, so will error on the server
      log.error('Failed to log to Datadog', e);
    }
  }) as T;
}

// On the server, logs are ingested to datadog via vercel log drain
export const datadogLogger = isServer
  ? {
      ...log,
      log: log.info,
    }
  : {
      ...datadogLogs.logger,
      log: withEnsureInit(datadogLogs.logger.log),
      debug: withEnsureInit(datadogLogs.logger.debug),
      info: withEnsureInit(datadogLogs.logger.info),
      warn: withEnsureInit(datadogLogs.logger.warn),
      error: withEnsureInit(datadogLogs.logger.error),
    };
